export default "__VITE_PUBLIC_ASSET__0910703f__"